'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var BUY_TOUCHLESS = exports.BUY_TOUCHLESS = 'buyTouchless';
var TALK_TO_SALES = exports.TALK_TO_SALES = 'talkToSales';
var TRIAL = exports.TRIAL = 'trial';


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.1086/js/_core/purchaseMotions/PurchaseMotionTypes.js
// module id = 284
// module chunks = 3 4 5